<p>webpay works!</p>
<p>{{ webpayData.url }}</p>
<p>{{ webpayData.token }}</p>

<form ngNoForm method="post" action="{{ webpayData.url }}" id="formWebpay">
    <input id="token_ws" type="hidden" name="token_ws" value="{{ webpayData.token }}" >
    <input type="submit" name="submit">
</form>